module.exports = __webpack_public_path__ + "static/media/Cracking the Coding Interview.ba162c8d.png";